import { capitalize } from '@sonar-software/sonar-ts-lib';
import classNames from 'classnames';
import { SonarText } from '@ui/text';
import { When } from 'react-if';
import React from 'react';
export const FilterContainer = ({ children, className, label }) => React.createElement("div", { className: classNames('filter-container', className) },
    React.createElement(When, { condition: Boolean(label) }, React.createElement(SonarText, null, capitalize(label))),
    children);
